export const engagementJumpstartEmailTemplatesId = "/engagement/jumpstart_email_templates/:id";
